<template>
  <div ref="entra_form">
    <b-overlay
      ref="overlay_index"
      :show="showLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card>
        <b-row>
          <b-col md="1" class="d-flex align-items-center mt-1">
            <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
          </b-col>

          <b-col md="2">
            <b-form-group label="Correlativo">
              <b-form-input
                v-model="form.documentCode"
                placeholder="Ingrese el Correlativo"
                trim
              />
            </b-form-group>
          </b-col>

          <b-col v-if="loanData" md="2">
            <b-form-group label="Establecimiento Origen">
              <b-form-input
                v-model="loanData.establishmentOrigin.name"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col v-if="loanData" md="2">
            <b-form-group label="Cliente">
              <b-form-input v-model="loanData.client.fullname" readonly />
            </b-form-group>
          </b-col>
          <b-col v-if="loanData" md="2">
            <b-form-group label="Fecha Límite">
              <b-form-input :value="formatDate(loanData.limitDate)" readonly />
            </b-form-group>
          </b-col>

          <b-col
            md="3"
            class="d-flex justify-content-end align-items-center mt-1"
          >
            <b-button variant="secondary" @click="validateLoan"
              >Validar</b-button
            >
            <b-button class="ml-1" variant="success" @click="markAsInvoiced"
              >Facturar</b-button
            >
            <b-button variant="primary" class="ml-1" @click="saveLoan"
              >Guardar</b-button
            >
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-4" v-if="loanData">
        <b-table
          :items="loanData.detail"
          :fields="fields"
          responsive
          hover
          class="border border-2 rounded mt-2"
        >
          <template #cell(state)="data">
            <span :class="getStateClass(data.item.state)">
              {{ data.item.state }}
            </span>
          </template>
        </b-table>
      </b-card>

      <b-modal
        v-model="showInvoiceModal"
        title="Información de Factura"
        @hide="resetInvoiceForm"
        hide-footer
        dialog-class="modal-dialog-centered"
      >
        <b-form @submit.prevent="confirmInvoice">
          <b-form-group label="Vendedor" label-for="sellerSelect">
            <v-select
              id="sellerSelect"
              v-model="invoiceForm.sellerId"
              :options="sellerOptions"
              :reduce="(option) => option.value"
              placeholder="Buscar vendedor"
              label="text"
              :filterable="true"
              :searchable="true"
            ></v-select>
            <b-form-invalid-feedback v-if="!invoiceForm.sellerId">
              ⚠️ Debe seleccionar un vendedor.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Tipo de Documento">
            <v-select
              v-model="selectedVoucher"
              :options="voucherSerials"
              label="text"
              :reduce="doc => doc"
              placeholder="Seleccione un tipo de documento"
            />
            <b-form-invalid-feedback v-if="!selectedVoucher">
              ⚠️ Debe seleccionar un tipo de documento.
            </b-form-invalid-feedback>
          </b-form-group>

          <div class="d-flex align-items-center">
            <b-form-input
              disabled
              class="mr-2"
              :value="selectedVoucher ? selectedVoucher.numeral : ''"
              style="width: 80px"
            />
            <b-form-input
              v-model="invoiceForm.billNumber"
              type="text"
              placeholder="Ingrese el número"
              required
            />
          </div>

          <div class="d-flex align-items-center mt-2">
            <b-button type="submit" variant="primary">Confirmar</b-button>
            <b-button
              variant="secondary"
              class="ml-2"
              @click="showInvoiceModal = false"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import LoanService from "@/services/LoanService";
import UserService from "@/services/UserService";
import VoucherService from "@/services/VoucherService";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      showLoading: false,
      showInvoiceModal: false,
      form: {
        documentCode: "",
      },
      loanData: null,
      invoiceForm: {
        sellerId: null,
        billNumber: "",
      },
      voucherSerials: [],
      selectedVoucher: null,
      clients: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único" },
        { key: "autopart.description", label: "Descripción de Autoparte" },
        { key: "autopart.originalCode", label: "Código Original" },
        { key: "qty", label: "Cantidad" },
        { key: "unitPrice", label: "Precio Unitario" },
        { key: "state", label: "Estado" },
      ],
    };
  },
  mounted() {
    this.getClients();
  },
  computed: {
    sellerOptions() {
      return this.clients.map((client) => ({
        value: client.id,
        text: `${client.fullname} - (${client.document})`,
      }));
    },
  },
  methods: {
    async loadVoucherSerials() {
      try {
        const response = await VoucherService.getVoucherById(
          this.loanData.establishmentOrigin.id,
          this.$store
        );

        if (response?.data?.rows && Array.isArray(response.data.rows)) {
          this.voucherSerials = response.data.rows.map((doc) => ({
            value: doc.typeDoc,
            text: doc.typeDoc,
            numeral: doc.numeral,
          }));
        } else {
          this.voucherSerials = [];
          this.$swal("Error", "No se encontraron vouchers para este establecimiento.", "error");
        }
      } catch (error) {
        console.error("Error al cargar seriales de voucher:", error);
        this.$swal("Error", "Ocurrió un error al obtener los vouchers.", "error");
        this.voucherSerials = [];
      }
    },

    async validateLoan() {
      if (!this.form.documentCode) {
        this.$swal(
          "Error",
          "Ingrese un correlativo antes de validar.",
          "error"
        );
        return;
      }

      try {
        this.showLoading = true;
        const response = await LoanService.validateLoan(
          this.form.documentCode,
          this.$store
        );

        if (response && response.statusCode === 200 && response.data) {
          if (response.data.state === "Completo") {
            this.$swal("Aviso", "Este préstamo ya se completó.", "info");
            this.loanData = null;
            return;
          }

          this.loanData = response.data;
          this.$swal(
            "Éxito",
            "El préstamo ha sido validado correctamente.",
            "success"
          );
        } else {
          this.loanData = null;
          this.$swal(
            "Error",
            "No se pudo validar el préstamo. Verifique el correlativo ingresado.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error al validar el préstamo:", error);
        this.$swal(
          "Error",
          "Ocurrió un problema al validar el préstamo.",
          "error"
        );
      } finally {
        this.showLoading = false;
      }
    },
    getStateClass(state) {
      switch (state) {
        case "Pendiente":
          return "badge badge-warning";
        case "Facturado":
          return "badge badge-success";
        case "Devuelto":
          return "badge badge-danger";
        default:
          return "badge badge-secondary";
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    },
    async markAsInvoiced() {
      if (this.loanData) {
        this.loanData.detail.forEach((item) => {
          if (item.state === "Pendiente") {
            item.state = "Facturado";
          }
        });
        this.$swal(
          "Éxito",
          "Los estados de las autopartes se han actualizado a Facturado.",
          "success"
        );
      }
    },
    async saveLoan() {
      const hasPending = this.loanData.detail.some(
        (item) => item.state === "Pendiente"
      );
      if (hasPending) {
        this.$swal(
          "Error",
          "No puede guardar mientras existan autopartes con estado Pendiente.",
          "error"
        );
        return;
      }
      await this.loadVoucherSerials();

      this.showInvoiceModal = true;
    },
    async getClients() {
      const resp = await UserService.getUsers("", this.$store);
      if (resp) {
        this.clients = resp.data.rows.filter(
          (user) => user.role.name === "Vendedor"
        );
      }
    },
    confirmInvoice() {
      if (!this.invoiceForm.sellerId || !this.invoiceForm.billNumber) {
        this.$swal("Error", "Debe completar todos los campos.", "error");
        return;
      }

      try {

        if (!this.selectedVoucher || !this.selectedVoucher.numeral) {
          this.$swal("Error", "Debe seleccionar un tipo de documento válido.", "error");
          return;
        }

        const fullBillNumber = `${this.selectedVoucher.numeral}-${this.invoiceForm.billNumber}`;

        const payload = {
          documentCode: this.loanData.documentCode,
          establishmentOriginId: this.loanData.establishmentOrigin.id,
          clientId: this.loanData.client.id,
          billNumber: fullBillNumber,
          registerById: this.invoiceForm.sellerId,
          autoparts: this.loanData.detail,
        };
        LoanService.updateLoan(this.loanData.id, payload, this.$store);
        this.$swal(
          "Éxito",
          "El préstamo y factura han sido guardados correctamente.",
          "success"
        );
        this.showInvoiceModal = false;
        this.$router.push("/prestamo/venta");
      } catch (error) {
        console.error("Error al guardar el préstamo con factura:", error);
        this.$swal(
          "Error",
          "Ocurrió un problema al guardar el préstamo con factura.",
          "error"
        );
      }
    },

    resetInvoiceForm() {
      this.invoiceForm.sellerId = null;
      this.invoiceForm.billNumber = "";
    },
  },
};
</script>
